<div class="timeline-wrap">
    <div class="timeline">
        @for (step of steps; track step) {
            <div
                class="timeline__item"
                [attr.data-label]="step.title"
                [ngClass]="{'timeline__item--active': isStepActive(step), 'timeline__item--marked': isStepMarked(step)}"
                (click)="changeStep(step)">
                <div class="timeline__step"></div>
                @if (step.active) {
                    <skl-validation-area
                        class="timeline__validation"
                        [areaId]="step.id">
                    </skl-validation-area>
                }
            </div>
        }
    </div>
</div>